/**
 * Error ActionTypes
 */

import { IErrorActionCreator } from "types/error_action_creator";

export enum Actions {
  SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE",
  HIDE_ERROR = "HIDE_ERROR",
}

const hideError: () => IErrorActionCreator = (): IErrorActionCreator => ({
  type: Actions.HIDE_ERROR,
});

const setErrorMessage: (payload: string) => IErrorActionCreator = (
  payload: string
): IErrorActionCreator => ({
  type: Actions.SET_ERROR_MESSAGE,
  message: payload,
});

export { hideError, setErrorMessage };



// WEBPACK FOOTER //
// ./src/components/Error/store/Actions.tsx